import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalJsonService {
  private randN: number = Math.floor(Math.random() * (5000 - 1)) + 1;
  private globalJsonSource: any = 'https://d3tmfelegj51yl.cloudfront.net/global-json/globalJson.json?rand=' + this.randN;
  public globalObj: any = {};
  private globalCopySubject = new BehaviorSubject('');
  public globalCopyObservable$ = this.globalCopySubject.asObservable();

  constructor(protected http: HttpClient) {}

  getGlobalCopy() {
    this.http.get(this.globalJsonSource).subscribe(
      (data) => {
        this.globalObj = data['copy'];
        this.setBehaviorSubject(this.globalObj);
      },
      (err) => {}
    );
  }

  setBehaviorSubject(n: any) {
    this.globalCopySubject.next(n);
  }
}
